<div class="audio-content">
  <div class="audio-progress" [ngStyle]="{ 'width': progress + '%' }"></div>
  <div class="audio-image">
    <img *ngIf="imagePath" [src]="imagePath">
  </div>
  <div class="audio-text">
    <span>{{text}}</span>
  </div>
  <div class="audio-controls" (click)="progressValidation()">
    <span>
      <audio controls #player>
        <source [src]="url" type="audio/mpeg">
      </audio>
    </span>
  </div>
</div>
